(function() { window.GUID_860fe757_18ff_4728_b12f_a46a89b26e90 = { getGuid: function() { return "860fe757-18ff-4728-b12f-a46a89b26e90"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class GridViewFixedHeaderHelper {
            static Start(gridView) {
                if (!this.GridViews) {
                    this.GridViews = new Array();
                    CS.DOM.$win.offon('scroll.gridviewfixedheader', function () {
                    });
                }
                this.GridViews.push(new GridViewFixedHeader(gridView));
            }
        }
        Controls.GridViewFixedHeaderHelper = GridViewFixedHeaderHelper;
        class GridViewFixedHeader {
            constructor(gridView) {
                this.GridViews = gridView;
            }
        }
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=gridview-fixed-header.js.map
